var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock4Img6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 101,
    viewBox: "0 0 95 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5306 0.229492L0.47168 37.4844L47.5306 74.7394L94.5895 37.4844L47.5306 0.229492Z",
    fill: "#3163D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6587 11.0811H86.1501C86.7845 11.0811 87.1366 11.5219 87.1366 11.8761V77.8593H8.67212V11.8761C8.67212 11.5219 9.02431 11.0811 9.6587 11.0811Z",
    fill: "white",
    stroke: "#EAEFFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.47168 37.4844L47.5306 74.7392L94.5895 37.4844V96.308C94.5895 98.4738 92.8339 100.23 90.6679 100.23H4.39322C2.22731 100.23 0.47168 98.4738 0.47168 96.308V37.4844Z",
    fill: "#60A5FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.051 69.719C51.059 65.7669 44.0042 65.7669 39.0121 69.719L1.76953 99.2029C2.46543 99.8346 3.38034 100.229 4.39434 100.229H90.6691C91.6829 100.229 92.598 99.8343 93.2938 99.2029L56.051 69.719Z",
    fill: "#3163D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock4Img6);
export default __webpack_public_path__ + "static/media/block_4_img_6.75a638a3a7d48ea7fccc44dd2c96a944.svg";
export { ForwardRef as ReactComponent };